<!-- 长胖原因溯源 -->
<template>
  <div class="q5">
    <div class="box" v-if="info">
      <img
        class="bg"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e8c98e00099ee5d7823b2d86ed2dba44.png"
        alt=""
      />
      <div class="c-item container">
        <div class="user-info">
          <div class="avatar" v-if="info.head_img">
            <img class="avatar-image" :src="info.head_img" alt="" />
          </div>
          <div class="nickname">{{ info.truename || info.nickname || '' }}</div>
        </div>
        <img
          class="status-image"
          :src="resultImage[info.queResultType]"
          alt=""
        />
      </div>
      <div
        class="c-item"
        v-for="(item, index) in info.obesityData"
        :key="index"
      >
        <div class="c-title">
          <img class="title-icon" :src="icon[index]" alt="" />
          <div class="title-text">{{ item.title }}</div>
        </div>
        <div class="w-list">
          <div
            class="w-item"
            v-for="(item1, index1) in item.content"
            :key="index1"
            >{{ index1 + 1 }}、{{ item1 }}
          </div>
        </div>
      </div>
      <div class="c-item course-container">
        <div class="course-box">
          <div class="course-content">
            <img
              class="dot"
              src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f29d97a36d51bdf43b4b05737d02c77c.png"
              alt=""
            />
            <div class="c-flex">
              <div class="c-flex-left"
                >现在，相信您已经大致了解自己的长胖原因</div
              >
              <img
                class="c-avatar"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/21cb47f0dcd2cfde1de8b5a5e0eab0d8.png"
                alt=""
              />
            </div>
            <div
              >别气馁也别焦虑，我们会陪你逐一解决这些问题，带你一步到位收获健康的好身材</div
            >
            <div class="c-desc">针对情况，请重点关注以下课程内容</div>
          </div>
        </div>
        <div class="camp-list">
          <div
            class="camp-item"
            v-for="(item, index) in info.recommend_content"
            :key="index"
          >
            <div class="camp-title">{{ item.title }}</div>
            <div class="camp-text">{{ item.content }}</div>
          </div>
        </div>
        <div class="my-course" @click="bindMyCourse">
          <img
            class="icon"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0cec1237411857d7ea5bbf350efd73e2.png"
            alt=""
          />
          <div class="text">我的课程</div>
          <div class="iconfont icon-you"></div>
        </div>
      </div>
      <img
        class="logo"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cna-ques-logo"
        alt=""
      />
    </div>
  </div>
</template>
<script>
import { getShareUrl } from '../../common.js'
import appApi from '@/common/app-common.js'
export default {
  data() {
    return {
      info: null,
      resultImage: {
        1: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d34942e9d69a91ac93f1cb179f40242c.png', //体内激素失衡
        2: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cd266b796273bea5a2186f5eeebb5cc4.png', //摄入过多升糖指数食物
        3: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d1adf383d5b8a9bb37035cb26ee00f86.png', //压力较大导致皮质醇、胰岛素等代谢紊乱
        4: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9d50ef090d4c882f8c0f1485df1465be.png', //盐分摄入较多，导致身体处于水肿状态
        5: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c0b44212cf7b3821f1f90743111cb3d5.png' //饮食结构严重失调
      },
      icon: [
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6256c6998176ae12c202e70d50a9c3b4.png',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/98ef26fa47c65a6165a954a77cf60c8a.png',
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/96c9977108f9b81fd3307e56b6e54c15.png'
      ]
    }
  },
  created() {
    this.getResult()
  },
  methods: {
    getResult() {
      let params = {
        que_user_id: this.$route.query.que_id,
        admin_uid: this.$route.query.admin_uid,
        que_id: this.$route.query.que_type
      }
      this.$http
        .getBaseAppWithHeader('que/QueBase/getQueResult', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            /* 过滤不存在数据的 */
            res.data.obesityData = res.data.obesityData.filter((item) => {
              return (
                item.content &&
                Array.isArray(item.content) &&
                item.content.length
              )
            })
            this.info = res.data
            this.$emit('copyUrl', getShareUrl(this.info.que_id))
          } else {
            this.$toast(res.msg)
          }
        })
    },
    bindMyCourse() {
      appApi.jumpMiniProgram({
        appId: 'gh_3da9370ac840',
        path: 'page/home/index'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-item {
  background: #ffffff;
  border-radius: 12px;
  padding: 20px;
  box-sizing: border-box;
  margin-bottom: 20px;
}

.c-title {
  display: flex;
  align-items: center;
  margin-bottom: 16px;

  .title-icon {
    width: 26px;
    height: 26px;
    object-fit: contain;
    margin-right: 6px;
  }

  .title-text {
    font-size: 20px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #27243c;
    line-height: 28px;
  }
}

.w-list {
  font-size: 11px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 600;
  color: #27243c;
  line-height: 20px;
}

.q5 {
  overflow: scroll;
  background-color: #f7f7f7;
  min-height: 100vh;
  box-sizing: border-box;

  .box {
    position: relative;
    background-image: linear-gradient(
      180deg,
      rgba(169, 157, 251, 1) 0px,
      rgba(169, 157, 251, 0) 350px
    );
    padding: 56px 16px 30px;

    .bg {
      position: absolute;
      right: 30px;
      top: 10px;
      width: 121px;
      height: 109px;
      object-fit: contain;
    }
  }

  .container {
    background: #ffffff;
    box-shadow: 0px 5px 9px 0px rgba(58, 55, 82, 0.03);
    border-radius: 16px;
    border: 2px solid #ffffff;
    padding: 0px;

    .user-info {
      margin-bottom: 5px;
      text-align: center;
      padding-bottom: 12px;
      margin: -26px 22px 0px;
      border-bottom: 1px dashed rgba(58, 55, 82, 0.16);

      .avatar {
        margin: 0 auto;
        width: 54px;
        height: 54px;
        border: 2.5px solid #fff;
        box-sizing: border-box;
        border-radius: 50%;
        overflow: hidden;
        margin-bottom: 6px;

        .avatar-image {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }

      .nickname {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #27243c;
        line-height: 22px;
      }
    }

    .status-image {
      margin: 0 auto;
      display: block;
      width: 335px;
      min-height: 170px;
      object-fit: contain;
    }
  }
}

.course-container {
  padding-top: 34px;

  .course-box {
    position: relative;
    margin-bottom: 16px;
    width: 100%;

    .course-content {
      padding: 16px;
      box-sizing: border-box;
      border-radius: 6px;
      background: linear-gradient(
        180deg,
        rgb(240, 238, 254) 0%,
        rgb(242, 240, 255) 100%
      );
      position: relative;
      z-index: 1;
      font-size: 11px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #73689d;
      line-height: 20px;

      .dot {
        width: 40px;
        height: 40px;
        position: absolute;
        left: 14px;
        top: 0;
        transform: translate(0%, -50%);
      }

      .c-flex {
        display: flex;
        align-items: flex-end;
        margin-bottom: 2px;

        .c-flex-left {
          flex: 1;
          flex-shrink: 0;
          overflow: hidden;
        }

        .c-avatar {
          width: 40px;
          height: 40px;
          object-fit: cover;
          margin-left: 20px;
        }
      }

      .c-desc {
        font-size: 15px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #73689d;
        line-height: 24px;
      }
    }
  }

  .course-box::after {
    content: '';
    position: absolute;
    z-index: 0;
    width: 0px;
    height: 0px;
    right: 50px;
    bottom: -10px;
    border-left: 20px solid rgb(242, 240, 255);
    border-bottom: 10px solid transparent;
    border-top: 10px solid transparent;
  }

  .camp-list {
    .camp-item {
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      border-bottom: 1px dashed rgba(58, 55, 82, 0.12);
      margin-bottom: 9px;

      .camp-title {
        position: relative;
        z-index: 1;
        padding-left: 8px;
        border-radius: 4px 3px 3px 4px;
        width: 90px;
        box-sizing: border-box;
        height: 20px;
        font-size: 11px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #ffffff;
        line-height: 20px;
        background: linear-gradient(
          180deg,
          #cdc4ff 0%,
          #9f91fe 80%,
          rgba(185, 174, 255, 1) 100%
        );
        margin-right: 10px;
      }

      .camp-title::after {
        content: '';
        position: absolute;
        z-index: -1;
        width: 14px;
        height: 14px;
        background: linear-gradient(
          135deg,
          #cdc4ff 0%,
          #9f91fe 80%,
          rgba(185, 174, 255, 1) 100%
        );
        right: 0;
        top: 50%;
        border-radius: 0px 4px 0px 0px;
        transform: translate(45%, -50%) rotate(45deg);
        transform-origin: center;
      }

      .camp-text {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-size: 11px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #27243c;
        line-height: 20px;
      }
    }

    .camp-item:last-child {
      border-bottom: none;
      margin-bottom: 0px;
    }
  }

  .my-course {
    margin-top: 12px;
    height: 42px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid #e1dede;
    display: flex;
    align-items: center;
    padding: 0px 16px;

    .text {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #27243c;
      line-height: 18px;
      margin-right: 10px;
    }

    .icon {
      width: 26px;
      height: 26px;
      object-fit: contain;
      margin-right: 10px;
    }

    .iconfont {
      font-size: 20px;
      color: rgba(39, 36, 60, 0.5);
    }
  }

  .desc {
    text-align: center;
    font-size: 10px;
    font-family: PingFangSC-Regular, PingFang SC;
    color: rgba(39, 36, 60, 0.36);
    line-height: 18px;
  }
}

.share {
  font-size: 24px;
}

.logo {
  height: 12px;
  margin: 20px auto 0px;
}
</style>
